import React from "react";

interface ToastContextProps {
    clearToasts: () => void;
    createToast: (message: string, type: ('success' | 'informational' | 'error' | 'warning'), onClose: () => void) => void;
    createSuccessToast: (message: string, onClose: () => void) => void;
    createInfoToast: (message: string, onClose: () => void) => void;
    createWarningToast: (message: string, onClose: () => void) => void;
    createErrorToast: (message: string, onClose: () => void) => void;
}

/**
 * A list of functions to use regarding spawning toasts on call. Make sure the file importing this is wrapped in a ToastProvider.
 * 
 * ## _
 * ### Functions
 * @param {function} clearToasts - Clears all toasts from queue, including the active one.
 * @param {function} createToast - Creates a toast. Needs a message, a type, and an optional onClose function call.
 * @param {function} createSuccessToast - Creates a success toast. Needs a message and an optional onClose function call.
 * @param {function} createInfoToast - Creates an informational toast. Needs a message and an optional onClose function call.
 * @param {function} createWarningToast - Creates a warning toast. Needs a message and an optional onClose function call.
 * @param {function} createErrorToast - Creates an error toast. Needs a message and an optional onClose function call.
 */
const ToastContext = React.createContext<ToastContextProps | undefined>(undefined);

export default ToastContext;